const columns = [
  {
    title: 'Business Unit',
    field: 'name',
    defaultSort: 'asc'
  },
  {
    title: 'BU-assigned ID',
    field: 'businessUnitCompanyId'
  },
  {
    title: 'Credit source system',
    field: 'creditSourceSystem'
  }
];

export default columns;
